import io from 'socket.io-client';
import { rootDir } from '@/common/utils/pathPrefix.util';

const rootPath = rootDir.replace(/[/]$/, '');
const socket = io({ path: `${rootPath}/ws`, autoConnect: false });

export default socket;
